<template>
<el-row class="search-wrapper" type="flex" justify="center">
  <div class="wass-wrapper">
    <div>
      <div class="wass-logo c-pointer" @click="clickLogo">
        <img src="@/assets/img/smart-logo1.png">
      </div>
      <w-search-input style="width:100%;" ref="searchInput" @search-action="searchAction" />
    </div>
    <w-frequent-visit-page-view ref="frequentVisitPageView" />
  </div>
</el-row>
</template>

<script>
import WSearchInput from '../components/SearchInput';
import WFrequentVisitPageView from './FrequentVisitPageView';

export default {
  name: 'WSearchView',
  components: {
    WSearchInput,
    WFrequentVisitPageView,
  },
  methods: {
    /**
     * 초기화면에서 검색 실행
     * @author Hunui
     * @param  {[type]} searchValue 검색어
     */
    searchAction(searchValue) {
      this.$emit('search-action', searchValue);
    },
    /**
     * 검색어 초기화
     * @author Hunui
     */
    reset() {
      this.$refs.searchInput.reset();
    },
    /**
     * 자주 방문하는 페이지 조회
     * @author Hunui
     */
    loadFrequentVisitPageData() {
      this.$refs.frequentVisitPageView.loadData();
    },
    clickLogo() {
      this.$emit('logo-click');
    },
  },
};
</script>

<style>
.wass-search-tab {margin-top: 50px}
.wass-wrapper {
  width: 54%;
  min-width: 750px
}
@media (max-width: 1600px) {
  .wass-wrapper {width: 70%;}
}
</style>



// WEBPACK FOOTER //
// src/views/frame/components/popup/SmartSearchPopup/SearchView/index.vue